<template>
  <div class="home-container">
    <div class="home-content">
      <!-- 搜索 -->
      <div>
        <el-form :model="searchForm" ref="searchForm" label-width="80px">
          <el-row>
            <el-col :span="6">
              <el-form-item
                label="楼栋名称"
                prop="ridgepoleId"
                style="width: 80%"
              >
                <el-select
                  v-model="searchForm.ridgepoleId"
                  clearable filterable
                  placeholder="请选择楼栋"
                  @change="ridgepoleSelect"
                >
                  <el-option
                    v-for="item in ridgepoleList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item
                label="单元名称"
                prop="ridgepoleId"
                style="width: 80%"
              >
                <el-select
                  v-model="searchForm.unitId"
                  clearable filterable
                  placeholder="请选择单元"
                  @change="unitSelect"
                >
                  <el-option
                    v-for="item in unitList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item
                label="楼层名称"
                prop="name"
                style="width: 80%"
              >
                <el-select
                  v-model="searchForm.floorId"
                  clearable filterable
                  placeholder="请选择楼层"
                >
                  <el-option
                    v-for="item in floorList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item
                label="房间名称"
                prop="roomName"
                style="width: 80%"
              >
                <el-input
                  v-model="searchForm.roomName"
                  placeholder="请输入房间名称"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="选择时间" prop="time" style="width: 80%">
                <el-date-picker
                  v-model="searchForm.time"
                  type="daterange"
                  align="right"
                  unlink-panels
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :picker-options="pickerOptions"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-button
                size="small"
                @click="onLoad"
                type="primary"
                icon="el-icon-search"
                >搜索</el-button
              >
              <el-button
                size="small"
                @click="restSearch"
                type="danger"
                icon="el-icon-refresh"
                >重置</el-button
              >
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div style="margin: 20px">
        <div style="margin: 20px; display: flex; align-items: center">
          <el-button
            size="small"
            @click="addDataRecord"
            type="primary"
            icon="el-icon-plus"
            >新增</el-button
          >
        </div>
      </div>
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="address" label="房屋信息" align="center">
        </el-table-column>
        <el-table-column prop="cycleTime" label="缴费周期" align="center">
        </el-table-column>
        <el-table-column
          prop="billCategoryName"
          label="缴费类型"
          align="center"
        >
        </el-table-column>
        <el-table-column prop="billPrice" label="缴费金额" align="center">
        </el-table-column>
        <el-table-column prop="payTime" label="支付时间" align="center">
        </el-table-column>
        <el-table-column prop="state" label="状态" align="center">
        </el-table-column>
        <el-table-column fixed="right" label="操作" align="center">
          <template slot-scope="scope">
            <el-button @click="handleClick(scope.row)" type="text" size="small"
              >删除</el-button
            >
            <el-button v-if="scope.row.state != '已核销'" @click="updataRecord(scope.row)" type="text" size="small"
              >修改</el-button
            >
            <el-button v-if="scope.row.state != '已核销'" @click="writeOff(scope.row)" type="text" size="small"
              >核销</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页器 -->
      <div class="block" style="margin-top: 15px">
        <el-pagination
          align="center"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
      <el-dialog title="核销" :visible.sync="dialogVisible" width="40%">
        <el-form :model="from" ref="Form" :rules="fromRules" label-width="80px">
          <el-row>
            <el-col :span="12">
              <el-form-item
                label="支付类型"
                prop="payType"
                label-width="100px"
                style="width: 80%"
              >
                <el-select clearable filterable v-model="from.payType" placeholder="请选择支付类型">
                  <el-option
                    v-for="item in payTypeList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label="核销金额"
                prop="price"
                label-width="100px"
                style="width: 80%"
              >
                <el-input-number
                  v-model="from.price"
                  :min="0"
                  label="请输入金额"
                ></el-input-number>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item
                label="核销时间"
                prop="price"
                label-width="100px"
                style="width: 80%"
              >
                <el-date-picker
                  v-model="from.writeOffTime"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="选择核销日期时间"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label="备注"
                prop="des"
                label-width="100px"
                style="width: 80%"
              >
                <el-input
                  type="textarea"
                  :rows="4"
                  placeholder="请输入备注"
                  v-model="from.des"
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="writeOffSubmit(1)">确 定</el-button>
        </span>
      </el-dialog>
      <el-dialog :title="moudelName" :visible.sync="isShowFlag" width="50%">
        <el-form :model="addData" ref="Forms" :rules="rules" label-width="80px">
          <el-row>
            <el-col :span="12">
              <el-form-item
                label="楼栋名称"
                prop="ridgepoleId"
                style="width: 80%"
              >
                <el-select
                  v-model="addData.ridgepoleId"
                  clearable filterable
                  placeholder="请选择楼栋"
                  @change="ridgepoleSelect"
                >
                  <el-option
                    v-for="item in ridgepoleList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label="单元名称"
                prop="unitId"
                style="width: 80%"
              >
                <el-select
                  v-model="addData.unitId"
                  clearable filterable
                  placeholder="请选择单元"
                  @change="unitSelect"
                >
                  <el-option
                    v-for="item in unitList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="楼层名称" prop="floorId" style="width: 80%">
                <el-select
                  v-model="addData.floorId"
                  clearable filterable
                  placeholder="请选择楼层"
                  @change="floorSelect"
                >
                  <el-option
                    v-for="item in floorList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="房间名称" prop="roomId" style="width: 80%">
                <el-select
                  v-model="addData.roomId"
                  clearable filterable
                  placeholder="请选择房间"
                >
                  <el-option
                    v-for="item in roomList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item
                label="账单金额"
                prop="billPrice"
                style="width: 80%"
              >
                <el-input-number
                  v-model="addData.billPrice"
                  :min="0"
                  label="请输入金额"
                ></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="选择时间" prop="time" style="width: 80%">
                <el-date-picker
                  v-model="addData.time"
                  type="daterange"
                  align="right"
                  unlink-panels
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :picker-options="pickerOptions"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="选择类型" prop="billCategoryId">
                <el-select
                  clearable filterable
                  v-model="addData.billCategoryId"
                  placeholder="请选择类型"
                >
                  <el-option
                    v-for="(item, ind) in typeData"
                    :key="ind"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="备注 " prop="billCategoryId">
                <el-input
                  type="textarea"
                  :rows="4"
                  placeholder="请输入内容"
                  v-model="addData.des"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="isShowFlag = false">取 消</el-button>
          <el-button type="primary" @click="onSubmit()">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import reg from "@/utils/reg";
export default {
  data() {
    return {
      searchForm: {
        billOrderNo: "",
        endTime: "",
        startTime: "",
        time: "",
        payType: "",
        ridgepoleId: "",
        unitId: "",
        floorId: "",
        roomName: "",
        billCategoryId: "",
        isXiaohu: "",
      },
      moudelName: "新增",
      isShowFlag: false,
      addData: {},
      from: {},
      baseUrL: process.env.VUE_APP_UPLOAD_REAL_PATH + "/bill/importTemplate",
      XiaohuList: [
        {
          id: 1,
          name: "是",
        },
        {
          id: 0,
          name: "否",
        },
      ],
      fromRules: {
        payType: [
          { required: true, message: "请选择支付类型", trigger: "blur" },
        ],
        price: [{ required: true, message: "请输入核销金额", trigger: "blur" }],
        writeOffTime: [
          { required: true, message: "请选择核销时间", trigger: "blur" },
        ],
      },
      rules: {
        ridgepoleId: [
          { required: true, message: "请选择楼栋", trigger: "blur" },
        ],
        unitId: [{ required: true, message: "请选择单元", trigger: "blur" }],
        floorId: [{ required: true, message: "请选择楼层", trigger: "blur" }],
        roomId: [{ required: true, message: "请选择房间", trigger: "blur" }],
        billCategoryId: [{ required: true, message: "请选择缴费类型", trigger: "blur" }],
        payType: [
          { required: true, message: "请选择支付类型", trigger: "blur" },
        ],
        billPrice: [
          { required: true, message: "请输入账单金额", trigger: "blur" },
        ],
        time: [{ required: true, message: "请选择时间周期", trigger: "blur" }],
      },
      payTypeList: [
        {
          id: 1,
          name: "微信",
        },
        {
          id: 2,
          name: "支付宝",
        },
        {
          id: 3,
          name: "现金",
        },
        {
          id: 4,
          name: "银行卡",
        },
        {
          id: 5,
          name: "对公转账",
        },
      ],
      tableData: [],
      dialogVisible: false,
      currentPage: 1, // 当前页码
      total: 20, // 总条数
      pageSize: 10, // 每页的数据条数
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      ridgepoleList: [],
      unitList: [],
      floorList: [],
      roomList: [],
      typeData: [],
    };
  },
  mounted() {
    this.onLoad();
  },
  methods: {
    // 修改账单
  updataRecord(row) {
      this.addData = JSON.parse(JSON.stringify(row));
      this.addData.time = row.cycleTime.split('~')
      this.ridgepoleSelect(this.addData.ridgepoleId)
      this.unitSelect(this.addData.unitId)
      this.floorSelect(this.addData.floorId,'updata')
    },
    onShowFla(){
      this.isShowFlag = true;
      this.moudelName = "修改";
    },
    addDataRecord() {
      for (let item in this.addData) {
        this.addData[item] = "";
      }
      this.isShowFlag = true;
      this.moudelName = "新增";
    },
    onSubmit() {
      this.$refs.Forms.validate((valid) => {
        if (valid) {
          let { billCategoryId, des, payType, billPrice, roomId, time, id } =
            this.addData;
          let data = {
            cycleStartTime: reg.filterDataTime(time[0]),
            cycleEndTime: reg.filterDataTime(time[1]),
            billCategoryId,
            roomId,
            payType,
            billPrice,
            des,
            id: id || "",
          };
          this.$Apis.billTemporaryAddUp(data).then((res) => {
            if (res.code == 200) {
              this.$message.success(res.msg);
              this.onLoad();
              this.isShowFlag = false;
            } else {
              this.$message.warning(res.msg);
            }
          });
        }
      });
    },
    writeOffSubmit(sum) {
      this.$refs.Form.validate((valid) => {
        if (valid) {
          let { ids, payType, des, price, writeOffTime } = this.from;
          let data = {
            id: this.writeOffId,
            payType,
            des,
            price,
            writeOffTime,
            type:1
          };
          this.$Apis.billTemporaryWriteOff(data).then((res) => {
            if (res.code == 200) {
              this.$message.success(res.msg);
              this.onLoad();
            } else {
              this.$message.warning(res.msg);
            }
          });
        }
      });
    },
    // 核销
    writeOff(row) {
      for (let item in this.from) {
        this.from[item] = "";
      }
      this.writeOffId = row.id;
      this.dialogVisible = true;
    },
    // 选择楼栋
    ridgepoleSelect(e) {
      this.$Apis.unitAllList({ ridgepoleId: e }).then((res) => {
        if (res.code == 200) {
          this.unitList = res.data;
        }
      });
    },
    // 选择单元
    unitSelect(e, row) {
      this.$Apis.floorAllList({ unitId: e }).then((res) => {
        if (res.code == 200) {
          this.floorList = res.data;
          if (row == "updata") {
            this.isAddModal = true;
          }
        }
      });
    },
    floorSelect(e,flag) {
      this.$Apis.roomAllList({ floorId: e }).then((res) => {
        if (res.code == 200) {
          if(flag){this.onShowFla()}
          this.roomList = res.data;
        }
      });
    },
    onLoad() {
      this.isShowloading = true;
      let {
        billOrderNo,
        time,
        payType,
        ridgepoleId,
        unitId,
        floorId,
        roomName,
        billCategoryId,
        isXiaohu,
      } = this.searchForm;
      let page = {
        current: this.currentPage,
        size: this.pageSize,
        billOrderNo,
        endTime: reg.filterDataTime(time[1]),
        startTime: reg.filterDataTime(time[0]),
        payType,
        ridgepoleId,
        unitId,
        floorId,
        roomName,
        billCategoryId,
        isXiaohu,
      };
      this.tableData = [];
      this.$Apis.houseAllList().then((res) => {
        if (res.code == 200) {
          this.ridgepoleList = res.data;
        }
      });
      this.$Apis.billCategoryAllList(page).then((res) => {
        if (res.code == 200) {
          this.typeData = res.data;
        }
      });
      this.$Apis.billTemporaryList(page).then((res) => {
        this.isShowloading = false;
        if (res.code == 200) {
          let { current, list, pages, total } = res.data;
          this.currentPage = current;
          this.size = pages;
          this.total = total;
          this.tableData = list;
          this.dialogVisible = false;
        }
      });
    },
    // 重置按钮
    restSearch() {
      for (let item in this.searchForm) {
        this.searchForm[item] = "";
      }
      this.onLoad();
    },
    //每页条数改变时触发 选择一页显示多少行
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.onLoad();
    },
    //当前页改变时触发 跳转其他页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.onLoad();
    },
    handleClick(row) {
      this.$confirm("您确定要删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$Apis.billTemporaryDel({ id: row.id }).then((res) => {
          if (res.code == 200) {
            this.$message.success(res.msg);
            this.onLoad();
          } else {
            this.$message.warning(res.msg);
          }
        });
      });
    },
  },
};
</script>

<style scoped >
/deep/.el-upload-list {
  display: none;
}
</style>